import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

/**
 * FV通過後のヘッダー切り替え
 */
const initHeaderChange = () => {
  const header = document.querySelector(".js-header");
  const fv = document.querySelector(".js-fv");

  if (!header || !fv) return;

  ScrollTrigger.create({
    trigger: fv,
    start: "bottom top",

    onEnter: () => {
      header.classList.add("is-change");
    },

    onLeaveBack: () => {
      header.classList.remove("is-change");
    },

    invalidateOnRefresh: true,

    // markers: true,
  });
};

window.addEventListener("load", () => {
  initHeaderChange();
});



/**
 * カウントアップアニメーション
 */
const initCountUp = () => {
  const countUpList = document.querySelector(".js-countup-list");
  const countUpElements = document.querySelectorAll(".js-countup");

  if (!countUpList || !countUpElements.length) return;

  ScrollTrigger.create({
    trigger: countUpList,
    start: "top 80%",
    once: true,

    onEnter: () => {
      countUpElements.forEach((el) => {
        const numberEl = el.querySelector(".js-countup-number");
        const target = Number(el.dataset.count);

        if (!numberEl || !Number.isFinite(target)) return;

        const counter = { value: 0 };

        gsap.to(counter, {
          value: target,
          duration: 1,
          ease: "power2.out",

          onUpdate: () => {
            numberEl.textContent = Math.floor(
              counter.value
            ).toLocaleString("ja-JP");
          },

          onComplete: () => {
            numberEl.textContent = target.toLocaleString("ja-JP");
          },
        });
      });
    },
  });
};

initCountUp();



/**
 * 棒グラフアニメーション
 */
const initBarCharts = () => {
  const charts = gsap.utils.toArray(".js-bar-chart");

  if (!charts.length) return;

  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  charts.forEach((chart) => {
    const bars = chart.querySelectorAll(".js-chart-bar");
    const arrowSvg = chart.querySelector(".js-chart-arrow svg");
    const badge = chart.querySelector(".js-chart-badge");

    if (!bars.length) return;

    if (prefersReducedMotion) {
      gsap.set(bars, {
        scaleY: 1,
      });

      if (arrowSvg) {
        gsap.set(arrowSvg, {
          clipPath: "inset(0% 0 0 0)",
        });
      }

      if (badge) {
        gsap.set(badge, {
          scale: 1,
          opacity: 1,
        });
      }

      return;
    }

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: chart,
        start: "top 75%",
        once: true,
      },
    });

    /* 棒グラフ */
    timeline.to(bars, {
      scaleY: 1,
      duration: 1.1,
      ease: "power3.out",
      stagger: {
        each: 0.07,
        from: "start",
      },
    });

    /* 矢印 */
    if (arrowSvg) {
      timeline.to(
        arrowSvg,
        {
          clipPath: "inset(0% 0 0 0)",
          duration: 1.2,
          ease: "power2.inOut",
        },
        "-=0.65"
      );
    }

    /* 円形ラベル */
    if (badge) {
      timeline.to(
        badge,
        {
          scale: 1,
          opacity: 1,
          duration: 0.5,
          ease: "back.out(1.7)",
        },
        "-=0.45"
      );
    }
  });
};
initBarCharts();



/**
 * Slide Up
 */
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.js-slideup').forEach((elm) => {
    ScrollTrigger.create({
      trigger: elm,
      start: 'top bottom',

      onEnter: function () {
        elm.classList.remove('init');
      },

      onLeaveBack: function () {
        elm.classList.add('init');
      },
    });
  });

});